<template>
    <DModal
        :title="__('customers.customers.switch_panel_modal.title')"
        is-medium
        is-confirm
        @close="closeModal"
        @confirm="sendPanelChangeRequest"
    >
        <DCard padding>
            <DFieldLoading
                v-if="loading"
                :is-loading="loading"
                is-big
                class="my-4 d-flex justify-content-center"
            />
            <DFormRow
                v-else
                :label="__('settings.brands.form.control_panel.default_panel')"
                :is-required="true"
            >
                <DSelect
                    id="default_panel"
                    :value="defaultPanel"
                    :options="controlPanels"
                    :placeholder="__('settings.brands.form.control_panel.default_panel')"
                    @update:value="changePanel"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>

import { ref } from 'vue'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import DFieldLoading from '~@/Components/Common/DFieldLoading'

const props = defineProps({
    customer: {
        type: Object,
        default: () => { return {} }
    }
})

const panel = ref(props.defaultPanel)
const defaultPanel = ref(null)
const controlPanels = ref([])
const loading = ref(true)

const emit = defineEmits(['close-modal', 'axios-message'])

const sendPanelChangeRequest = function () {
    window.axios.post(
        route('customers.customers.set_customer_panel_type', { customer: props.customer.id }),
        { panel: panel.value }
    ).then(() => {
        emitMessage(
            true,
            __('customers.customers.switch_panel_success'),
            true
        )
    })
        .catch((error) => {
            const message = (error && error.response && error.response.data.message.length > 0)
                ? error.response.data.message
                : __('customers.customers.switch_panel_error')

            emitMessage(
                true,
                message,
                false
            )
        })
}

const getDefaultPanel = function () {
    window.axios.get(route('customers.customers.default_customer_panel', { customer: props.customer.id }))
        .then(response => {
            defaultPanel.value = response.data.defaultPanel ?? null
            controlPanels.value = response.data.controlPanels ?? []
            loading.value = false
        })
}

getDefaultPanel()

const changePanel = function (value) {
    panel.value = value
}

const emitMessage = function (showMessage, message, success) {
    emit('axios-message', {
        showMessage: showMessage,
        message: message,
        success: success
    })
}

const closeModal = function () {
    emit('close-modal')
}

</script>

<style scoped>

</style>
